module.exports = __webpack_public_path__ + "fonts/VetoSans-Italic.5889b56a.eot";